export default __webpack_public_path__ + "static/media/Ticket.6a321269.svg";